import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class EmpreendimentosAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'empreendimentos';
	}
	/**
	 * save
	 *
	 * Salva os dados
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @param  object
	 * @return object Promise
	 */
	public save(data) {
        // return this._call(this.__entity + '/save', data);
		return this._call(this.__entity + '/save', {data} , 'post');        
	}
		/**
	 * get by incorporadoraId
	 *
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @param  object
	 * @return object Promise
	 */
	public getByIncorporadoraId(data) {
		let dados = {
			IncorporadoraId:data['id']
		};
		if(data['nomeEmpreendimento']){
			dados['Nome_like']=data['nomeEmpreendimento'];
		}
        // return this._call(this.__entity + '/save', data);
		return this._call(this.__entity, dados , 'get');        
	}
}


// WEBPACK FOOTER //
// ./src/api/empreendimento.api.ts